// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import iltCourseContentsSelector from '../../redux/selectors/iltCourseContentsSelector';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { ILTCourse, Progress } from '../../types/Model';
import iltCourseInformationSelector from '../../redux/selectors/iltCourseInformationSelector';

export function useFetchIltCourseInformation(id: number): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getIltCourseDataActions.request({ id }));
  }, [id])
}

export const useIltCourseInformation = (id: number): ILTCourse => {
  return useSelector(iltCourseInformationSelector.makeIltCourseByIdSelector(id))
}

export function useFetchIltCourseContents(id: number, preventLoading?: boolean): () => void {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getIltCourseContentsDataActions.request({ id, preventLoading }));
  }, [id])
}

export function useUpdateProgress(id: number): (progress: Progress) => void {
  const dispatch = useDispatch();
  const refetchContents = useFetchIltCourseContents(id, true);

  return useCallback((progress: Progress) => {
    dispatch(actionCreatorsList.updateIltCourseProgressActions.request({
      id,
      progress,
      onSuccess: () => refetchContents()
    }))
  }, [id])
}

export function useProgress(id: number): Progress[] {
  return useSelector(iltCourseContentsSelector.makeIltCourseProgressDataByIdSelector(id));
}

export function useHasCourse(id: number): boolean {
  return useSelector(iltCourseInformationSelector.makeIltCourseHasCourseByIdSelector(id));
}

export function useHasSample(id: number): boolean {
  return useSelector(iltCourseInformationSelector.makeIltCourseHasSampleByIdSelector(id));
}
